import React from 'react';
import ProfileElement from './profileTab';
import { ProfileTabs } from '../../utils/const';
import Nav from 'react-bootstrap/Nav';
import { connect } from 'react-redux';

const ProfileTabLinks = ({ show_settings_history }) => {
	return (
		<div>
			<Nav
				className=" mobile_tabs profile-tabs"
				defaultActiveKey={window.location.pathname}
			>
				{Object.keys(ProfileTabs).map((detail, index) =>
					detail === 'History' && show_settings_history !== true ? null : (
						<ProfileElement
							key={index}
							{...ProfileTabs[detail]}
						/>
					))}
			</Nav>
		</div>
	);
};

const mapStateToProps = (state) => ({
	show_settings_history: state.rootReducer.myStepDetails.show_settings_history,
});

export default connect(mapStateToProps)(ProfileTabLinks);
